import { SagaIterator } from "redux-saga";
import { call, put, takeEvery } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setActionLoading, updateIsCorrect } from "../../repository/slice";
import toast from "react-hot-toast";
import i18n from "../../../../locales/i18n";
import { tokens } from "../../../../locales/tokens";

function* moderateAnswerWorker({ payload }: any): SagaIterator {
  const { id, userQuestionId, isCorrect } = payload;

  try {
    yield put(setActionLoading(true));
    const { data, message, isError }: IResponse<any> = yield call(
      requester.post,
      `/api/admin/quiz-attempt/${id}/answers/${userQuestionId}/moderate`,
      { isCorrect }
    );

    if (isError) {
      console.error(message);
    } else {
      yield put(
        updateIsCorrect({
          attemptId: String(id),
          userQuestionId,
          isCorrect,
        })
      );
      toast.success(
        i18n.t(
          isCorrect ? tokens.test.correctAnswer : tokens.test.incorrectAnswer
        )
      );
    }
  } catch (error) {
    console.error("moderateAnswerWorker: ", error);
  } finally {
    yield put(setActionLoading(false));
  }
}

export function* moderateAnswerWatcher() {
  yield takeEvery("@saga/MODERATE_ANSWER", moderateAnswerWorker);
}
